import { Link } from "wouter";
import Hero from "../components/Hero";
import ServiceCard from "../components/ServiceCard";
//import TestimonialCard from "../components/TestimonialCard";
import { services } from "../data/services";
//import { testimonials } from "../data/testimonials";

export default function Home() {
  return (
    <div>
      {/* Hero Section */}
      <Hero />

      {/* Services Section */}
      <section className="py-16 md:py-24 bg-[#F9FAFB]" data-testid="section-services">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-heading font-semibold text-[#033644] mb-4">
              Nuestros Servicios
            </h2>
            <p className="text-base md:text-lg text-gray-600 max-w-2xl mx-auto">
              Ofrecemos soluciones tecnológicas integrales diseñadas para
              impulsar el crecimiento y la innovación de tu empresa
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
            {services.map((service) => (
              <ServiceCard key={service.id} service={service} />
            ))}
          </div>

          <div className="text-center mt-12">
            <Link 
              href="/services"
              className="inline-block bg-[#033644] text-white font-heading font-semibold px-8 py-3 rounded-lg text-lg hover-elevate active-elevate-2 transition-all duration-300"
              data-testid="button-ver-servicios"
            >
              Ver Todos los Servicios
            </Link>
          </div>
        </div>
      </section>

      {/* Testimonials Section 
      <section className="py-16 md:py-24 bg-white" data-testid="section-testimonials">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-heading font-semibold text-[#033644] mb-4">
              Lo Que Dicen Nuestros Clientes
            </h2>
            <p className="text-base md:text-lg text-gray-600 max-w-2xl mx-auto">
              La confianza de nuestros clientes es nuestro mayor logro
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            {testimonials.map((testimonial) => (
              <TestimonialCard key={testimonial.id} testimonial={testimonial} />
            ))}
          </div>
        </div>
      </section>*/}

      {/* CTA Section */}
      <section className="py-16 md:py-24 bg-gradient-to-r from-[#033644] to-[#1E3A8A]" data-testid="section-cta">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-white mb-6">
            ¿Listo para Transformar Tu Negocio?
          </h2>
          <p className="text-xl text-gray-200 mb-8">
            Contáctanos hoy y descubre cómo podemos ayudarte a alcanzar tus
            objetivos tecnológicos
          </p>
          <Link 
            href="/contact"
            className="inline-block bg-[#FFA500] text-white font-heading font-semibold px-10 py-4 rounded-lg text-lg hover-elevate active-elevate-2 transition-all duration-300"
            data-testid="button-contacto-cta"
          >
            Contáctanos Ahora
          </Link>
        </div>
      </section>
    </div>
  );
}